import React from 'react';
import './mainstyle.css';
import FooterDetails from './components/FooterDetails';

function Footer() {
  return (
    <footer>
      <FooterDetails />
    </footer>
  );
}

export default Footer;
